import { useSnapshot } from "valtio"
import { useState, useEffect } from "react"
import on from './on2.png'
import off from './off.png'
import { enquiryStore } from "../enquiry/enquiry-data"

export default function AgChoice(props) {
    const { label, record, name, callback = f => f, isDisabled = false } = props
    let yesVal = props.yesVal
    let noVal = props.noVal
    // const imRecord = useSnapshot(record?record:{})
    //useSnapshot(record)
    const [checked1, setChecked] = useState(props.value)

    return (
        <div className="columns" style={{alignItems: 'center'}}>
            <div className="p-1" style={{fontSize: '0.9rem', 
            fontWeight: 'bold', textAlign: 'right'}}>
                {noVal}
            </div>
            <div className="column is-2 p-1" style={{zoom: '1.1', textAlign: 'center', 
            justifyContent: 'center'}} onClick={() => {
                if (props.disabled) return
                const newval = checked1 === yesVal ? noVal : yesVal
                callback(newval)
                setChecked(newval)
            }}>
                {
                    (checked1 === yesVal) ?
                        <img height='36px' width='36px' src={on}></img> :
                        <img height='36px' width='36px' src={off}></img>
                }
            </div>
            <div className="column is-6 p-1" style={{fontSize: '0.9rem', 
            fontWeight: 'bold', textAlign: 'left'}}>
                {yesVal}
            </div>
        </div>
    )

    return (
        <table className="is-narrow" style={{ border: '1px solid white', borderRadius: '13px', fontSize: '0.8rem', cursor: isDisabled ? "not-allowed" : "default" }}>
            <tr style={{ border: 'none' }}>
                {checked1 === noVal ? <td style={{
                    border: 'none', padding: '0px', margin: '0px',
                    textAlign: 'right', fontStyle: 'italic', fontWeight: "bold"
                }}>{yesVal}</td> : <td style={{
                    border: 'none', padding: '0px',
                    textAlign: 'right', fontStyle: 'italic'
                }}>{yesVal}</td>
                }
                <td style={{ border: 'none', width: '2rem', paddingTop: '3px', paddingLeft: '2px', paddingRight: '0px' }}>
                    <div style={{ width: '1.7rem' }} onClick={isDisabled ? null : () => {
                        if (props.disabled) return
                        const newval = checked1 === yesVal ? noVal : yesVal
                        if (props.record) record[name] = newval
                        callback(newval)
                        setChecked(newval)
                    }}>
                        {
                            (checked1 === yesVal) ?
                                <img height='36px' width='36px' src={on}></img> :
                                <img height='36px' width='36px' src={off}></img>
                        }
                    </div>
                </td>
                {(checked1 === yesVal) ? <td style={{ border: 'none', padding: '0px', textAlign: 'left', fontStyle: 'italic', fontWeight: 'bold' }}>{noVal}</td> : <td style={{ border: 'none', padding: '0px', textAlign: 'left', fontStyle: 'italic' }}>{noVal}</td>}
            </tr>
        </table>
    )
}

